import { IncidentStatus } from "@/gql/graphql";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";
import { IncidentRecord } from "@/app/Incidents/GraphQL/incidentRecordQuery";

export function useCanEditIncident(incident: IncidentRecord) {
  const { isAdmin } = useTenant();

  return isAdmin
    ? incident.status !== IncidentStatus.Closed
    : incident.status === IncidentStatus.Reported;
}
